module.exports = __webpack_public_path__ + "img/電気回路_6_5_1.9182ea6f.png";